export const siteConfig = {
    name: "Met", // First part of the title
    nameAccent: "Maät", // Second (accented) part of the title
    fullName: "Met Maät",
    legalName: "Met Maät B.V.",
    kvk: "42138772",
    vat: "NL869892927B01",
    logo: "/logo/logo-mm-default-sm80-white.png",
    social: {
        linkedin: "https://www.linkedin.com/in/bendegens/",
        email: "info@metmaat.com",
        emailLabel: "info@metmaat.com",
        mobile: "+31 6 22759049",
    },
    address: {
        street: "Penderskoolhofweg 7",
        postalCode: "6343RG",
        city: "Klimmen",
        country: "Netherlands",
        full: "Penderskoolhofweg 7, 6343RG, Klimmen, Netherlands"
    },
    navigation: [
        { key: 'home', path: '/' },
        { key: 'services', path: '/services' },
        { key: 'methodology', path: '/methodology' },
        { key: 'about', path: '/about' },
    ],
    partners: {
        softwareLeader: {
            logo: '/partners/software-leader.svg',
        },
        jellybean: {
            logo: '/partners/jellybean.png',
        },
        modernDay: {
            logo: '/partners/modern-day.svg',
        },
    },
    legalLinks: [
        { key: 'disclaimerTitle', path: '/disclaimer' },
        { key: 'privacyTitle', path: '/privacy-statement' },
    ],
    taglineKey: undefined as string | undefined,
};
